import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../Components/Common/Loader";
import { useParams } from "react-router-dom";
import {
  Container,
  Row,
  Card,
  CardBody,
  Table,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Col,
  CardHeader,
  Nav,
} from "reactstrap";
import classnames from "classnames";
import { Transactions } from "../../Components/custom/TransactionsTable";
import { phoneNumberFormatter } from "../../slices/phone-number-formatter";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { getSellerQuery } from "../../queries";
import { SellerTerminals } from "../../Components/custom/SellerTerminals";
import { SellerCards } from "../../Components/custom/SellerCards";
import { SellerAddress } from "../../Components/custom/SellerAddress";
import SellerStatsDiagram from "../../Components/custom/SellerStatsDiagram";
import { SellerClickPayments } from "../../Components/custom/SellerClickPayments";
import { SellerBozorPay } from "../../Components/custom/SellerBozorPay";
import { SellerProducts } from "../../Components/custom/SellerProducts";
import { useTranslation } from "react-i18next";

const SellerViewPage = () => {
  const [activeTab, setActiveTab] = useState("1");
  const { sellerId } = useParams();
  const { t } = useTranslation();

  const { data: sellerData } = useQuery(getSellerQuery(sellerId));

  const seller = sellerData?.data?.data || {};

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={t("Seller Details")} pageTitle={t("Sellers")} />
        {seller?.user ? (
          <>
            <Row>
              <div className="col-xxl-8">
                <SellerStatsDiagram />
              </div>

              <div className="col-xxl-4">
                <Card>
                  <CardBody className="p-4">
                    <div>
                      <div className="mt-3 text-center">
                        <h5 className="mb-4">{`${seller.user.firstName} ${seller.user.lastName}`}</h5>
                      </div>
                      <div className="table-responsive">
                        <Table className="table mb-0 table-borderless">
                          <tbody>
                            <tr>
                              <th>
                                <span className="fw-medium">{t("FIO")}</span>
                              </th>
                              <td>{`${seller.user.firstName} ${seller.user.lastName}`}</td>
                            </tr>
                            <tr>
                              <th>
                                <span className="fw-medium">{t("Phone")}</span>
                              </th>
                              <td>
                                {phoneNumberFormatter(seller.user.phoneNumber)}
                              </td>
                            </tr>
                            <tr>
                              <th>
                                <span className="fw-medium">{t("Status")}</span>
                              </th>
                              <td>
                                {(seller.status || "active") === "active" ? (
                                  <span className="badge bg-success-subtle text-success text-uppercase">
                                    {t("Active")}
                                  </span>
                                ) : (
                                  <span className="badge bg-danger-subtle text-danger text-uppercase">
                                    {t("Blocked")}
                                  </span>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <th>
                                <span className="fw-medium">{t("Comment")}</span>
                              </th>
                              <td>{seller.comment || "-"}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </Row>
            <Col xxl={12} style={{ marginTop: "50px" }}>
              <Card className="mt-xxl-n5">
                <CardHeader>
                  <Nav
                    className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => {
                          tabChange("1");
                        }}
                      >
                        <i className="fas fa-home"></i>
                        {t("Adresses")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => {
                          tabChange("2");
                        }}
                        type="button"
                      >
                        <i className="far fa-user"></i>
                        {t("Cards")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({ active: activeTab === "3" })}
                        onClick={() => {
                          tabChange("3");
                        }}
                        type="button"
                      >
                        <i className="far fa-user"></i>
                        {t("Terminals")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({ active: activeTab === "4" })}
                        onClick={() => {
                          tabChange("4");
                        }}
                        type="button"
                      >
                        <i className="far fa-user"></i>
                        {t("Click Services")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({ active: activeTab === "5" })}
                        onClick={() => {
                          tabChange("5");
                        }}
                        type="button"
                      >
                        {t("Products")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({ active: activeTab === "6" })}
                        onClick={() => {
                          tabChange("6");
                        }}
                        type="button"
                      >
                        {t("Bozor Pay")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>
                <CardBody className="p-4">
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      {activeTab === "1" ? <SellerAddress /> : null}
                    </TabPane>
                    <TabPane tabId="2">
                      {activeTab === "2" ? <SellerCards /> : null}
                    </TabPane>
                    <TabPane tabId="3">
                      {activeTab === "3" ? <SellerTerminals /> : null}
                    </TabPane>
                    <TabPane tabId="4">
                      {activeTab === "4" ? <SellerClickPayments /> : null}
                    </TabPane>
                    <TabPane tabId="5">
                      {activeTab === "5" ? <SellerProducts /> : null}
                    </TabPane>
                    <TabPane tabId="6">
                      {activeTab === "6" ? <SellerBozorPay /> : null}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
            <Transactions sellerId={sellerId} />
          </>
        ) : (
          <Loader />
        )}
      </Container>
    </div>
  );
};

export default SellerViewPage;
